import StatusButtonGroup from "./StatusButtonGroup"

export const READY_STOCK_FILTER_OPTIONS = [
  { value: "", label: "All", color: "secondary", icon: "bx-list-ul" },
  { value: "1", label: "Ready Stock", color: "success", icon: "bx-check-circle" },
  { value: "0", label: "Not Ready", color: "warning", icon: "bx-time-five" },
]

const ReadyStockFilterButtons = ({
  value = "",
  onChange,
  label = "",
  size = "sm",
  disabled = false,
  className = "mb-0",
}) => {
  return (
    <StatusButtonGroup
      name="vs_ready_stock"
      label={label}
      value={value || ""}
      onChange={onChange}
      options={READY_STOCK_FILTER_OPTIONS}
      size={size}
      disabled={disabled}
      className={className}
    />
  )
}

export default ReadyStockFilterButtons
